<template>
  <div class="dataUploadWrap">
    <div class="componentTop">
        <div class="componentText">课程附件</div>
    </div>
    <div class="courseWrap">
      <div class="newCourseAdd" @click="isAddNewCourse = true">
        <a-icon type="plus" />
        添加新的课程附件
      </div>
      <div class="addNewCourse" v-if="isAddNewCourse">
        <div class="btnBox">
          <a-upload
            name="file"
            :accept="'.mp4, .wmv, .zip, .rar, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .jpg, .jpeg, .png'"
            :action="apis.upload.apiUpload+appUtils.getResearchId()"
            :beforeUpload="beforeUpload"
            @change="changeUpload"
            :file-list="accFileList"
          >
            <a-button>
              <a-icon type="upload" />上传附件
            </a-button>
          </a-upload>
          <!-- 暂时没有课程标签, 后续再做 -->
          <!-- <a-button class="resourceBtn" @click="showResource()">从资源库选择</a-button> -->
        </div>
        <p style="margin-top: 10px;color: #999;">支持格式类型：mp4、wmv、zip、rar、word、excel、ppt、jpg、png，大小不超过200M</p>
        <a-form-model
          ref="ruleForm"
          :model="accForm"
          :rules="accRules"
          :wrapper-col="wrapperCol"
          class="accFormMain"
        >
          <a-form-model-item prop="accName">
            <a-input v-model="accForm.accName" placeholder="请输入附件的标题" /><span class="mustSpell">（必填）</span>
          </a-form-model-item>
          <a-form-model-item prop="accDesc">
            <a-input v-model="accForm.accDesc" type="textarea" rows="5" placeholder="请输入附件说明，不超过200字" /><span class="mustSpell">（必填）</span>
          </a-form-model-item>
          <a-form-model-item class="sbmBtnBox">
              <a-button @click="cancelSbm()">取消提交</a-button>
              <a-button @click="onSubmit" type="primary"><a-icon type="upload" />确认提交</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
      <div class="courseworkList">
        <div class="oneCoursework" v-for="(item, idx) in attachmentList" :key="idx">
          <a-form-model
            :ref="item.editStatus ? 'editForms' : 'nothing'"
            :model="editForm"
            :rules="editRules"
            :wrapper-col="editWrapperCol"
          >
            <div class="courseworkTop">
              <div class="titleBox">
                <a-row>
                  <a-col :span="18" class="titleMain">
                    <div class="title" v-if="!item.editStatus"><a-icon type="folder" style="color: #707070;" /> {{item.title}}</div>
                    <div class="titleEdit" v-if="item.editStatus">
                      <a-icon type="folder" style="color: #707070;" />
                      <a-form-model-item prop="attachName">
                        <a-input v-model="editForm.attachName" />
                      </a-form-model-item>
                    </div>
                  </a-col>
                  <a-col :span="6" style="display: flex;justify-content: flex-end;" v-if="!item.editStatus">
                    <!-- <span style="margin-right: 20px;" @click="previewFile(item)" v-if="item.fileName.split('.')[1].indexOf('m') == -1"> -->
                    <span style="margin-right: 20px;" @click="previewFile(item)">
                      <img src="../../../../static/images/icon_eye.png" alt="" title="预览附件">
                    </span>
                    <span style="margin-right: 20px;" @click="downloadFile(item)">
                      <img src="../../../../static/images/icon_download.png" alt="" title="下载附件">
                    </span>
                    <span style="margin-right: 20px;" @click="updateAttach(item)">
                      <img src="../../../../static/images/icon_upload.png" alt="" title="更新附件">
                    </span>
                    <span style="margin-right: 20px;" @click="editAttach(item)">
                      <img src="../../../../static/images/icon_edit.png" alt="" title="编辑附件">
                    </span>
                    <span @click="delAttach(item)">
                      <img src="../../../../static/images/icon_trash.png" alt="" title="删除附件">
                    </span>
                  </a-col><a-col :span="6" style="display: flex;justify-content: flex-end;" v-if="item.editStatus">
                    <a-button @click="cancelEditSbm(item)" style="margin-right: 20px;">取消</a-button>
                    <a-button @click="onEditSubmit(item)" type="primary">确认</a-button>
                  </a-col>
                </a-row>
              </div>
              <div class="titleDesc">
                <a-row v-if="!item.updateStatus">
                  <a-col :span="8" class="fileBox">
                    <span>文件名称：</span>
                    <span class="fileName">{{item.fileName}}</span>
                  </a-col>
                  <a-col :span="8">
                    <span>附件大小：</span>
                    <span>{{item.fileSize}} MB</span>
                  </a-col>
                </a-row>
                <div class="btnBox" v-if="item.updateStatus">
                  <a-upload
                    name="file"
                    :accept="'.mp4, .wmv, .zip, .rar, .doc, .docx, .pdf, .xls, .xlsx, .ppt, .pptx, .jpg, .jpeg, .png'"
                    :action="apis.upload.apiUpload+appUtils.getResearchId()"
                    :beforeUpload="beforeEditUpload"
                    @change="changeEditUpload"
                    :file-list="editFileList"
                  >
                    <a-button>
                      <a-icon type="upload" />上传附件
                    </a-button>
                  </a-upload>
                  <!-- 暂时没有课程标签, 后续再做 -->
                  <!-- <a-button class="resourceBtn" @click="showResource()">从资源库选择</a-button> -->
                </div>
                <p style="margin-top: 10px;color: #999;" v-if="item.updateStatus">支持格式类型：mp4、wmv、zip、rar、word、excel、ppt、jpg、png，大小不超过200M</p>
                <div class="onSbmBtn">
                  <a-button @click="cancelUpdate(item)" v-if="item.updateStatus" style="margin-right: 16px;">取消提交</a-button>
                  <a-button @click="sbmUpdate(item)" type="primary" v-if="item.updateStatus"><a-icon type="upload" />确认提交</a-button>
                </div>
              </div>
            </div>
            <div class="courseworkMain">
              <h4>材料说明：</h4>
              <p v-if="!item.editStatus">{{item.description}}</p>
              <a-form-model-item prop="attachDesc" v-if="item.editStatus" style="marginBottom: 0;width: 160%">
                <a-input v-model="editForm.attachDesc" type="textarea" />
              </a-form-model-item>
            </div>
          </a-form-model>
        </div>
      </div>
    </div>
    <ResourceLibrary ref="ResourceLibrary"></ResourceLibrary>
  </div>
</template>

<script>
import ResourceLibrary from './component/resourceLibrary';

export default {
  components: {
    ResourceLibrary
  },
  data(){
    return {
      attachmentList: [],
      isAddNewCourse: false,
      accFileList: [],
      editFileList: [],
      accFileSize: '',
      editFileSize: '',
      // 添加附件
      wrapperCol: { span: 22 },
      accForm: {
        accName: '',
        accDesc: ''
      },
      accRules: {
        accName: [
          { required: true, message: '请输入附件标题', trigger: 'blur' },
          { max: 30, message: '最多输入30个字符', trigger: 'blur' }
        ],
        accDesc: [
          { required: true, message: '请输入附件的介绍', trigger: 'blur' },
          { max: 200, message: '最多输入200个字符', trigger: 'blur' }
        ]
      },
      // 编辑附件信息
      editWrapperCol: { span: 14 },
      editForm: {
        attachName: '',
        attachDesc: ''
      },
      editRules: {
        attachName: [
          { required: true, message: '请输入附件标题', trigger: 'blur' },
          { max: 30, message: '最多输入30个字符', trigger: 'blur' }
        ],
        attachDesc: [
          { required: true, message: '请输入附件的介绍', trigger: 'blur' },
          { max: 200, message: '最多输入200个字符', trigger: 'blur' }
        ]
      }
    };
  },
  created (){
    this.getAllAttachment();
  },
  methods: {
    getAllAttachment(){
      let url = this.apis.courseDataUpload.getAllAttachmentByResearchId + this.appUtils.getResearchId();
      this.http.get(url)
      .then((res)=>{
        let attList = res.data;
        attList.forEach((item)=>{
          item.editStatus = false;
          item.updateStatus = false;
        });
        this.attachmentList = attList;
      }).catch((err)=> {
        console.log(err);
      });
    },
    showResource(){
      // this.$refs.ResourceLibrary.showModal();
    },
    previewFile(item){
      if (item.fileName.indexOf('mp4') > 0 || item.fileName.indexOf('wmv') > 0){
        let html = "<body style='background:black'><div style='width:900px;margin:auto;'><video controls width='100%' height='600px' autoplay src='"+item.path+"'></video></div></body>";
        window.open().document.write(html);
      } else {
        window.open(this.apis.preview + item.path);
      }
    },
    downloadFile(item){
      window.open(item.path);
    },
    updateAttach(item){
      item.updateStatus = true;
    },
    editAttach(item){
      item.editStatus = true;
      this.editForm.attachName = item.title;
      this.editForm.attachDesc = item.description;
    },
    delAttach(item){
      let that = this;
      this.$confirm({
        title: '提示',
        content: '确定删除该课程附件吗?',
        onOk() {
          that.sbmDelAttach(item.attId);
        },
        onCancel() {
        }
      });
    },
    sbmDelAttach(attId){
      let url = this.apis.courseDataUpload.delAttachment + attId;
      this.http.delete(url)
      .then((res)=>{
        if (res.status == 0){
          this.$message.success('删除成功');
          this.getAllAttachment();
          this.$emit('getResearchMessageById');
        } else {
          this.$message.error(res.message);
        }
      }).catch((err)=> {
        console.log(err);
      });
    },
    // 上传附件
    beforeUpload(file){
      if (file.name.indexOf('mp4') > 0 || file.name.indexOf('wmv') > 0 || file.name.indexOf('zip') > 0 || file.name.indexOf('rar') > 0 || file.name.indexOf('doc') > 0 || file.name.indexOf('docx') > 0 || file.name.indexOf('xls') > 0 || file.name.indexOf('xlsx') > 0 || file.name.indexOf('ppt') > 0 || file.name.indexOf('pptx') > 0 || file.name.indexOf('jpg') > 0 || file.name.indexOf('jpeg') > 0 || file.name.indexOf('png') > 0 || file.name.indexOf('pdf') > 0){
          if ((file.size/1024/1024).toFixed(2) < 200){
            // console.log('执行上传');
          } else {
            this.$message.error('上传文件大小超过200M');
            this.$nextTick(()=>{
              this.accFileList = [];
              this.accFileSize = '';
            });
            return false;
          }
      } else {
          this.$message.error('上传文件格式不符');
          this.$nextTick(()=>{
            this.accFileList = [];
            this.accFileSize = '';
          });
          return false;
      }
    },
    changeUpload(res){
      if (res.file){
        let fileList = [...res.fileList];
        fileList = fileList.slice(-1);
        this.accFileList = fileList;
        this.accFileSize = (this.accFileList[0].size/1024/1024).toFixed(2);
      }
    },
    // 更新附件
    cancelUpdate(item){
      item.updateStatus = false;
      this.editFileList = [];
      this.editFileSize = '';
    },
    sbmUpdate(item){
      let that = this;
      this.$confirm({
        title: '提示',
        content: '确定提交课程附件吗?',
        onOk() {
          that.updateSbmAttach(item.attId);
        },
        onCancel() {
        }
      });
    },
    updateSbmAttach(attId){
      let url = this.apis.courseDataUpload.saveOrUpdateAttachment;
      this.http.post(url,{
        'fileName': this.editFileList[0].name ? this.editFileList[0].name : '',
        'fileSize': this.editFileSize,
        'path': this.editFileList[0].response.data.filePath ? this.apis.upload.aliyuncs+'/'+this.editFileList[0].response.data.filePath : '',
        'attId': attId,
        'updatedBy': this.appUtils.getUserId()
      })
      .then((res)=>{
        if (res.status == 0){
          this.$message.success('提交成功');
          this.getAllAttachment();
        } else {
          this.$message.error(res.message);
        }
      }).catch((err)=> {
        console.log(err);
      });
    },
    beforeEditUpload(file){
      if (file.name.indexOf('mp4') > 0 || file.name.indexOf('wmv') > 0 || file.name.indexOf('zip') > 0 || file.name.indexOf('rar') > 0 || file.name.indexOf('doc') > 0 || file.name.indexOf('docx') > 0 || file.name.indexOf('xls') > 0 || file.name.indexOf('xlsx') > 0 || file.name.indexOf('ppt') > 0 || file.name.indexOf('pptx') > 0 || file.name.indexOf('jpg') > 0 || file.name.indexOf('jpeg') > 0 || file.name.indexOf('png') > 0){
          if ((file.size/1024/1024).toFixed(2) < 200){
            // console.log('执行上传');
          } else {
            this.$message.error('上传文件大小超过200M');
            this.$nextTick(()=>{
              this.editFileList = [];
              this.editFileSize = '';
            });
            return false;
          }
      } else {
          this.$message.error('上传文件格式不符');
          this.$nextTick(()=>{
            this.editFileList = [];
            this.editFileSize = '';
          });
          return false;
      }
    },
    changeEditUpload(res){
      if (res.file){
        let fileList = [...res.fileList];
        fileList = fileList.slice(-1);
        this.editFileList = fileList;
        this.editFileSize = (this.editFileList[0].size/1024/1024).toFixed(2);
      }
    },
    // 添加附件
    cancelSbm(){
      this.isAddNewCourse = false;
      this.accFileList = [];
      this.accFileSize = [];
      this.accForm.accDesc = '';
      this.accForm.accName = '';
    },
    onSubmit(){
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let that = this;
          this.$confirm({
            title: '提示',
            content: '确定提交课程附件吗?',
            onOk() {
              if (that.accFileList.length > 0){
                that.sbmAccessory();
              } else {
                that.$message.warning('请上传附件');
              }
            },
            onCancel() {
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    sbmAccessory(){
      let url = this.apis.courseDataUpload.saveOrUpdateAttachment;
      this.http.post(url,{
        'fileName': this.accFileList[0].name ? this.accFileList[0].name : '',
        'fileSize': this.accFileSize,
        'description': this.accForm.accDesc,
        'path': this.accFileList[0].response.data.filePath ? this.apis.upload.aliyuncs+'/'+this.accFileList[0].response.data.filePath : '',
        'createdBy': this.appUtils.getUserId(),
        'researchId': this.appUtils.getResearchId(),
        'title': this.accForm.accName
      })
      .then((res)=>{
        if (res.status == 0){
          this.$message.success('提交成功');
          this.cancelSbm();
          this.getAllAttachment();
          this.$emit('getResearchMessageById');
        } else {
          this.$message.error(res.message);
        }
      }).catch((err)=> {
        console.log(err);
      });
    },
    // 编辑附件信息
    cancelEditSbm(item){
      item.editStatus = false;
    },
    onEditSubmit(item){
      this.$refs.editForms[0].validate(valid => {
        if (valid) {
          let that = this;
          this.$confirm({
            title: '提示',
            content: '确定修改附件信息吗?',
            onOk() {
              that.sbmEditAttchMsg(item.attId);
            },
            onCancel() {
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    sbmEditAttchMsg(attId){
      let url = this.apis.courseDataUpload.saveOrUpdateAttachment;
      this.http.post(url,{
        'title': this.editForm.attachName,
        'description': this.editForm.attachDesc,
        'attId': attId,
        'updatedBy': this.appUtils.getUserId()
      })
      .then((res)=>{
        if (res.status == 0){
          this.$message.success('提交成功');
          this.getAllAttachment();
        } else {
          this.$message.error(res.message);
        }
      }).catch((err)=> {
        console.log(err);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.dataUploadWrap{
  .componentTop{
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 25px 40px;
  }
  .componentText{
    font-size: 30px;
    color: #333333;
  }
  .courseWrap{
    user-select:none;
    padding: 0 40px;
    .newCourseAdd{
      height: 60px;
      background-color: #FAFAFA;
      line-height: 60px;
      border: 1px dashed #D9D9D9;
      border-radius: 5px;
      cursor: pointer;
      color: #999999;
      margin-bottom: 25px;
    }
    .addNewCourse{
      background:rgba(250,250,250,1);
      border:1px dashed rgba(217,217,217,1);
      border-radius:4px;
      margin-bottom: 25px;
      padding: 16px 24px;
      text-align: start;
      .btnBox{
        position: relative;
        .resourceBtn{
          position: absolute;
          top: 0;
          left: 130px;
        }
      }
      .accFormMain{
        .mustSpell{
          position: absolute;
          top: -10px;
          right: -60px;
          color: #999;
        }
        .sbmBtnBox{
          text-align: center;
          button{
            margin-right: 16px;
          }
        }
      }
    }
    .courseworkList{
      text-align: start;
      .oneCoursework{
        border:1px solid rgba(232,232,232,1);
        box-shadow:0px 4px 12px rgba(238,238,238,1);
        border-radius:2px;
        margin-bottom: 25px;
        .courseworkTop{
          min-height: 80px;
          background: #FAFAFA;
          border-bottom: 1px solid #E8E8E8;
          padding: 16px 43px 12px 25px;
          .titleBox{
            height: 24px;
            line-height: 24px;
            position: relative;
            .title{
              width: 70%;
              font-size: 16px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }
            .titleEdit{
              width: 100%;
              height: 30px;
              line-height: 30px;
              font-size: 16px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              position: absolute;
              top: 0px;
              left: 0px;
              position: relative;
              input{
                display: inline-block;
                width: 500px;
                height: 28px;
                position: absolute;
                top: -30px;
                left: 22px;
              }
            }
            span{
              display: inline-block;
              width: 24px;
              height: 24px;
              cursor: pointer;
              img{
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }
          }
          .titleDesc{
            margin-top: 5px;
            color: #999;
            .fileBox{
              display: flex;
              align-items: center;
              color: #666;
              .fileName{
                display: inline-block;
                width: 70%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .btnBox{
              margin-top: 10px;
              position: relative;
              .resourceBtn{
                position: absolute;
                top: 0;
                left: 130px;
              }
            }
            .onSbmBtn{
              display: flex;
              justify-content: center;
            }
          }
        }
        .courseworkMain{
          padding: 25px 43px 20px 25px;
          h4{
            color: #666;
          }
          p{
            color: #999;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
</style>